import { Component } from 'react';
import { FieldProps } from 'formik';
import { Box, StyledTextArea } from '../';
import { StyledSystemProps } from '../../../theme/StyledSystemProps';
import { Label } from '../../../typography';

type FormTextAreaProps = Omit<FieldProps, 'meta'> &
  StyledSystemProps & {
    label?: string;
    color?: string;
    placeholder?: string;
    disabled?: boolean;
    readOnly?: boolean;
    value?: any;
  };

class FormTextArea extends Component<FormTextAreaProps, {}> {
  static defaultProps = {
    mb: 3,
    width: '100%',
    type: 'string',
    flex: 1,
    minWidth: '150px',
  };

  render() {
    const { field, label, disabled, placeholder, readOnly, value } = this.props;
    return (
      <Box {...this.props}>
        <Label htmlFor={field.name}>{label}</Label>
        <StyledTextArea
          disabled={disabled}
          id={field.name}
          px={2}
          {...field}
          placeholder={placeholder}
          readOnly={readOnly}
          value={value}
        />
        {/* <ErrorMessage name={field.name}>
          {msg => (
            <Span mt={2} color="error" textAlign="right">
              {msg}
            </Span>
          )}
        </ErrorMessage> */}
      </Box>
    );
  }
}

export default FormTextArea;
